import { datadogLogs } from '@datadog/browser-logs';
import { type UseQueryOptions, useQuery } from '@tanstack/react-query';

import { TimeConstants } from '../../../constants/time';
import type { AppReviewPromptEligibilityRes } from '../dto/response/app-review-prompt-eligibility.res.dto';
import { UserApi } from '../user.api';

/**
 * 인앱 리뷰 팝업의 서버 측 노출 조건(구매·앱 사용 이력) 충족 여부 조회 훅.
 * 호출 조건(앱 웹뷰·로그인·FE 재노출 정책 통과 등)은 options.enabled로 제어한다.
 */
const useAppReviewPromptEligibilityQuery = (
  options?: Omit<
    UseQueryOptions<AppReviewPromptEligibilityRes>,
    'queryKey' | 'queryFn' | 'meta'
  >,
) => {
  const queryResult = useQuery({
    queryKey: UserApi.queryKeys.getAppReviewPromptEligibility(),
    queryFn: () => UserApi.getAppReviewPromptEligibility(),
    staleTime: TimeConstants.FIVE_MINUTES,
    meta: {
      // 비필수 백그라운드 체크 — 실패해도 고객 알림 없이 로그만 남기고 미노출(eligible=false)로 자연 처리
      onError: (error: unknown) =>
        datadogLogs.logger.error('인앱 리뷰 노출 조건 확인 실패', { error }),
    },
    ...options,
  });

  return { ...queryResult, eligible: queryResult.data?.eligible ?? false };
};

export default useAppReviewPromptEligibilityQuery;
